export const propertyTypeData = [
	{
		id: 1,
		name: "Hotel",
	},
	{
		id: 2,
		name: "Cottage",
	},
	{
		id: 3,
		name: "Resort",
	},
	{
		id: 4,
		name: "Hostel",
	},
	{
		id: 5,
		name: "Apartment",
	},
];
